import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getColor } from '@chakra-ui/theme-tools';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['track', 'filledTrack'];
var baseStyleTrack = {
  bg: 'gray.300',
  borderRadius: 'lg'
};
function baseStyleFilledTrack(props) {
  var c = props.colorScheme,
    t = props.theme,
    isIndeterminate = props.isIndeterminate;
  var bgColor = "".concat(c, ".400");
  var gradient = "linear-gradient(\n    to right,\n    transparent 0%,\n    ".concat(getColor(t, bgColor), " 50%,\n    transparent 100%\n  )");
  return _objectSpread({
    transitionProperty: 'dimensions',
    transitionDuration: 'slow'
  }, isIndeterminate ? {
    bgImage: gradient
  } : {
    bgColor: bgColor
  });
}
var baseStyle = function baseStyle(props) {
  return {
    filledTrack: baseStyleFilledTrack(props),
    track: baseStyleTrack
  };
};
var sizes = {
  sm: {
    track: {
      h: '0.25rem'
    }
  },
  md: {
    track: {
      h: '0.5rem'
    }
  },
  lg: {
    track: {
      h: '0.75rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
var ProgressBar = {
  parts: parts,
  sizes: sizes,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
export { ProgressBar as default };